import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";

@observer
export class DownloadButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.reader.downloadButtonTooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<polygon points="28 28 4 28 2 28 2 30 30 30 30 28 28 28" />
					<polygon points="18 20 18 2 14 2 14 20 8 17 8 20 16 24 24 20 24 17 18 20" />
				</svg>
			</i>
		</Button>;
	}
}
